export default __webpack_public_path__ + "static/media/PulseHD.3a561aec.png";